/**
 * Jerarquía de roles del CRM (de mayor a menor privilegio):
 * `Super Admin` > `Admin` > `Manager` > `Sales Rep` > `User`.
 *
 * Roles autorizados para abrir el dialer flotante y el selector de presencia.
 * Cualquier rol de `Sales Rep` hacia arriba puede:
 *  - Registrar el Twilio Voice Device al login.
 *  - Hacer y recibir llamadas.
 *  - Cambiar su propia presencia.
 *
 * Para ajustar quién puede usar el módulo de llamadas, editar este array.
 */
export const CALL_DIALER_ROLES: readonly string[] = [
  'Sales Rep',
  'Manager',
  'Admin',
  'Super Admin'
];

export function canUseCallDialer(roleName: string | undefined | null): boolean {
  if (!roleName) return false;
  return CALL_DIALER_ROLES.includes(roleName);
}
